const Rack = {

    // FIELDS
    "rack_no": "رقم الرف",
    "capacity": "السعة",
    "location": "الموقع",
    "search": "بحث",

    // PAGE HEADER
    "rack": "رف",

    // ERROR
    "error_rack_no": "أدخل رقم الرف",
    "error_capacity": "أدخل السعة",
    "error_location": "أدخل الموقع",
    "error_positive": "أدخل رقماً موجباً فقط",

    // TABLE HEADER
    "table_rack_no": "رقم الرف",
    "table_capacity": "السعة",
    "table_location": "الموقع",
}

export default Rack;